import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';


@Injectable()
export class AdmManageChatIdleTimeService {

  constructor(private _httpClient: IesHttpClient) {
  }


  getChatTime() {
    return this._httpClient.get(AppUrl.getChatIdleTime);
  }

  // Calling Method to Update the Concurrent Exams Data
  updateChatTime(params: any) {
    return this._httpClient.post(AppUrl.getChatIdleTime, params);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-chat-idle-time/adm-manage-chat-idle-time.service.ts